import React from 'react';
import { 
  getGeneNCBIid, 
  getDiseaseLink, 
  getPmidLink, 
  variantLink, 
  getNctidLink,
  referenceLink 
} from './MappingFunctions';
import { 
  EXT_NCBI_GENE_LINK, 
  EXT_UNIPROT_LINK, 
  EXT_ENSEMBL_LINK 
} from '../config/constants';
import { renderDefaultValueCols } from '@/utils/renderDefaultValueCols';

export const renderGeneNCBILink = (geneNcbis) => {
  if (!geneNcbis) return '';
  const geneLink = `${EXT_NCBI_GENE_LINK}${geneNcbis}`;
  return (
    <a href={geneLink} target="_blank" rel="noopener noreferrer">
      {geneNcbis} <i className="fa fa-external-link" aria-hidden="true"></i>
    </a>
  );
};

export const renderEnsemblLinks = (value) => {
  const result = renderDefaultValueCols(value);
  if (result === '-') return '-';

  const values = Array.isArray(result) ? result : [result];
  const delimiter = '|';

  return values.map((val, index) => (
    <span key={val}>
      <a
        href={`${EXT_ENSEMBL_LINK}${val}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        {val}
        <i className="fa fa-external-link px-1" aria-hidden="true"></i>
      </a>
      {index < values.length - 1 && (
        <span className="px-1">{delimiter}</span>
      )}
    </span>
  ));
};


export const renderUniProtLinks = (ids, values) => {
  const delimiter = '|';
  return ids?.map((id, index) => (
    <span key={id}>
      <a href={`${EXT_UNIPROT_LINK}${id}`} target="_blank" rel="noopener noreferrer">
        {values[index]}
        {id && <i className="fa fa-external-link px-1" aria-hidden="true"></i>}
      </a>
      <span className="px-1">{index !== ids?.length - 1 && delimiter}</span>
    </span>
  ));
};

export const renderChemblLinks = (chemIDs) => {
  if (!chemIDs || chemIDs.length === 0) return null;
  
  const idsArray = Array.isArray(chemIDs) ? chemIDs : [chemIDs];
  
  return (
    <React.Fragment>
      {idsArray.map(id => (
        <a
          key={id}
          href={`https://www.ebi.ac.uk/chembl/explore/compound/${id}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          {id}<i className="fa fa-external-link" aria-hidden="true"></i>
        </a>
      ))}
    </React.Fragment>
  );
};

export const renderReferenceLink = (data) => {
  const { reference, reference_type } = data;
  if (reference_type === 'PMID' && reference) {
    return referenceLink(reference);
  } else if (reference_type === 'NCTID' && reference) {
    return getNctidLink(reference);
  }
  return null;
};